import VueMeetingSelector from '@/components/MeetingSelector/VueMeetingSelector.vue';

export default VueMeetingSelector;
